export default {
  modify: {
    steper: {
      choose_charger: '选择充电桩',
      choose_attribute: '选择属性',
      confirm_save: '确认修改'
    },
    next: '下一步',
    previous: '上一步',
    old_value: '原数据',
    change_to: '修改为',
    select_charger_brand: '选择电桩品牌',
    select_business_status: '选择需要修改的状态',
    select_has_ready_status: '选择需要修改的状态',
    select_warranty_expired_date: '选择维保到期时间',
    enter_rated_power: '请输入额定功率',
    enter_rated_current: '请输入额定功率',
    enter_rated_voltage: '请输入额定电压',
    minimum_turn_on_balance: '最低启动充电金额',
    minimum_charging_balance: '最低停止充电金额',
    enter_minimum_turn_on_balance: '请输入最低启动充电金额',
    enter_minimum_charging_balance: '请输入最低停止充电金额',
    edit_success: '属性修改成功'
  }
}
